import ViewConstructor from './../components/ViewConstructor';

import Cookie from 'js-cookie';

/**
  Class GalleryTopBar represents the top bar within the photo gallery. It will handle the account links for logging in, logging out, and viewing the favorites next to it as well as the details navigation on the top left when on the details page.
*/
class GalleryTopBar extends ViewConstructor {
  /**
  Component did mount

  @params {mountId} - accepts string as mount id
  */
  componentDidMount() {
    var that = this;
    var $ref = $(`#${ this.state.generatedId }`);

    $(window).bind('user-changed', function() {
      var user = that.cookie.getJSON('gallery-user');
      that.updateFavCount();

      if (user && user.email) {
        that.$ref.find('.topbar__account__info__login').hide();
        that.$ref.find('.topbar__account__info__logout').show();
      } else if (user) {
        that.$ref.find('.topbar__account__info__login .login').hide();
        that.$ref.find('.topbar__account__info__login .create').show();
      } else {
        that.$ref.find('.topbar__account__info__login').show();
        that.$ref.find('.topbar__account__info__logout').hide();

        that.$ref.find('.topbar__account__info__login .create').hide();
        that.$ref.find('.topbar__account__info__login .login').show();
      }
    });

    $(window).bind('show-create-account', function() {
      // if no cookie, show notification
      if (!Cookie.get('create-account-dismissed')) {
        $('.create-account-notification').addClass('show');
      }
    });

    $(window).bind('hide-create-account', function() {
      $('.create-account-notification').removeClass('show');
      Cookie.set('create-account-dismissed', 'no-more-show');
    });

    $('.dismiss-create-account').on('click', function() {
      $(window).trigger('hide-create-account');
    });
    
    if (!("ontouchstart" in document.documentElement)) {
      $ref.find('.topbar__account__info__logout').on('mouseover', function() {
        $ref.find('.topbar__account__info__logout').addClass('hover');
      }).on('mouseleave', function(){
        $ref.find('.topbar__account__info__logout').removeClass('hover');
      });
    } else {
      $ref.find('.topbar__account__info__logout > div').on('click', function() {
        $(this).closest('.topbar__account__info__logout').toggleClass('dropdown');
      });
    }

    this.updateState({
      favCount: 0,
    });
  }
  componentDidEnter() {
    var that = this;
    var user = that.cookie.getJSON('gallery-user');

    if (user && !user.email) {
        that.$ref.find('.topbar__account__info__login .login').hide();
        that.$ref.find('.topbar__account__info__login .create').show();
      } else {
        that.$ref.find('.topbar__account__info__login .create').hide();
        that.$ref.find('.topbar__account__info__login .login').show();
      }
  }

  updateFavCount() {
    let $ref = $(`#${ this.state.generatedId }`);
    var user = Cookie.getJSON('gallery-user');

    var favCount = $('.fav-count');

    if (user) {
      this.updateState({
        favCount: user.favorites.length
      });      
    } else {
      this.updateState({
        favCount: 0
      });
    }

    favCount.text(this.state.favCount);
  }

  render(data) {
    return `
      <div class="topbar">`+(!this.state.isBasic ? 
        `<div class="topbar__account">
          <div class="topbar__account__backtosearch">&nbsp;</div>
          <a class="topbar__account__backtohome" href="${ this.state.baseUrl }">Back to Gallery Home</a>
          <div class="topbar__account__info">
            <div class="topbar__account__info--row">
              <div class="topbar__account__info__favorites"><a href="${ this.state.baseUrl }/my-account/favorites"><span class="heart-icon active"></span> <span class="fav-count">0</span> Favorites</a></div>
              <div class="topbar__account__info__login">
                <a href="${ this.state.baseUrl }/my-account/login" class="login"><span class="account-icon"></span>Sign In</a>
                <a href="${ this.state.baseUrl }/my-account/create" class="create"><span class="account-icon"></span>Create Account</a>
              </div>
              <div class="topbar__account__info__logout">
                <div><span class="account-icon"></span> My Account</div>
                <ul>
                  <li><a href="${ this.state.baseUrl }">Gallery Home</a></li>
                  <li><a href="${ this.state.baseUrl }/my-account/favorites">My Favorites</a></li>
                  <li><a href="${ this.state.baseUrl }/my-account">Settings</a></li>
                  <li><a href="${ this.state.baseUrl }/my-account/logout">Sign Out</a></li>
                </ul>
              </div>
            </div>
          </div>
          </div>`:`<div class="topbar__account"><a class="topbar__account__backtohome" href="${ this.state.baseUrl }">Back to Gallery Home</a></div>`)+`
        <div class="topbar__details__navigation"></div>
      </div>
    `;
  }
}

export default GalleryTopBar;


// WEBPACK FOOTER //
// ./src/scripts/site/gallery-views/GalleryTopBar.js